/**
 * React Query keys for workspace locations.
 * List root is `locations`; detail rows use `location` (historical spelling).
 */
export const locationsQueryKeys = {
  /** Prefix: all location list caches. */
  root: ['locations'] as const,
  all: (workspaceId: string | null | undefined) =>
    ['locations', workspaceId ?? null] as const,
  list: (
    workspaceId: string | null | undefined,
    page: number,
    limit: number,
    filters: string | null,
    queryKeySuffix?: string,
  ) =>
    [
      'locations',
      workspaceId ?? null,
      page,
      limit,
      filters,
      ...(queryKeySuffix ? [queryKeySuffix] : []),
    ] as const,
  detail: (
    workspaceId: string | null | undefined,
    locationId: string | null | undefined,
  ) => ['location', workspaceId ?? null, locationId ?? null] as const,
} as const;
